import React from 'react';
import NodeCard from './NodeCard';

const NodesGrid = ({ nodes, onEdit, onDelete }) => {
  if (!Array.isArray(nodes) || nodes.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {nodes.map(node => (
        <NodeCard
          key={node.id}
          node={node}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default NodesGrid;